import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  Col,
  Row,
  Spinner,
} from "reactstrap";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import axios from "axios";

const ModifyModal = ({ isOpen, toggle, projectData, async, modifyOptions }) => {
  const initialValues = {
    role: "", // Default empty string, will be set to "1", "2", or "3"
  };

  const validationSchema = Yup.object({
    role: Yup.string().required("Please select a role"),
  });

  const handleSubmit = (values, { setSubmitting }) => {
    const data = {
      user_id: projectData.user_id,
      project_id: projectData.project_id,
      role_id: values.role,
    };
    axios
      .put("https://althameen.net/dashboard/v1/projects/update-role", data)
      .then((response) => {
        async(); // Assuming this is a function to refresh data
        toggle();
      })
      .catch((error) => {
        console.log("Error updating role:", error);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };
console.log();

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Modify Role</ModalHeader>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, errors, touched, setFieldValue, isSubmitting }) => (
          <Form>
            <ModalBody>
              <Row className="mb-3">
                <Col>
                  <Label className="fw-semibold me-2">Name : </Label>{projectData.name}
                </Col>
                <Col>
                  <Label className="fw-semibold me-2">Mobile : </Label> {projectData.mobile}
                </Col>
              </Row>

              <div className="mb-3 mt-3">
                <h5 className="fw-semibold">Capacity:</h5>
                <Row className="ms-2">
                  <Col>
                    <Label>
                      Owner: {projectData.super_admin_count}/{projectData.super_admin_maximum}
                    </Label>
                  </Col>
                  <Col>
                    <Label>
                      Coordinators: {projectData.admin_count}/{projectData.admin_maximum}
                    </Label>
                  </Col>
                  <Col>
                    <Label>
                      Viewer: {projectData.viewer_count}/{projectData.viewer_maximum}
                    </Label>
                  </Col>
                </Row>
              </div>

              <FormGroup tag="fieldset">
                <h5 className="fw-semibold">Change Role:</h5>
                <div className="d-flex flex-wrap ms-5">
                  {modifyOptions.owner && (
                    <FormGroup check className="me-3">
                      <Label check>
                        <Input
                          type="radio"
                          name="role"
                          value="1"
                          defaultChecked={values.role === "1"}
                          onChange={() => setFieldValue("role", "1")}
                        />
                        Owner
                      </Label>
                    </FormGroup>
                  )}
                  {modifyOptions.coordinator && (
                    <FormGroup check className="me-3">
                      <Label check>
                        <Input
                          type="radio"
                          name="role"
                          value="2"
                          defaultChecked={values.role === "2"}
                          onChange={() => setFieldValue("role", "2")}
                        />
                        Coordinator
                      </Label>
                    </FormGroup>
                  )}
                  {modifyOptions.viewer && (
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="radio"
                          name="role"
                          value="3"
                          defaultChecked={values.role === "3"}
                          onChange={() => setFieldValue("role", "3")}
                        />
                        Viewer
                      </Label>
                    </FormGroup>
                  )}
                </div>
                {errors.role && touched.role && (
                  <div className="text-danger mt-2">{errors.role}</div>
                )}
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button type="button" color="secondary" onClick={toggle}>
                Cancel
              </Button>
              <Button type="submit" color="primary" disabled={isSubmitting}>
                {isSubmitting ? <Spinner size="sm" className="me-2" /> : null}
                Update
              </Button>
            </ModalFooter>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default ModifyModal;